import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HomeDashboard from './pages/home-dashboard';
import HomeMyCompany from './pages/home-mia-azienda';

import StatsDashboard from './pages/stats';
import HistoryPayments from './pages/history_payments';

import LogAuditUser from './pages/log_audit_user';
import CestinoAziendale from "pages/cestino-documenti";
import HomeInventory from './pages/home-inventory';

import AcvHome from './pages/acv-home';
import CCOHome from './pages/cco-home';
import RicambiCCO from './pages/ricambi-cco';
import StoricoCCO from './pages/storico-cco';

import CilindriPaniera from './pages/cilindripaniera';
import RaddrizzatriciCCO from './pages/raddrizzatrici-cco';

import GruHome from './pages/gru-home';
import GruConfigurazione from './pages/gru-configurazione';
import GruMagazzino from './pages/gru-magazzino';
import GruInterventi from './pages/gru-interventi';
import GruStorico from './pages/gru-storico';
import GruStatistiche from './pages/gru-statistiche';

import ColataHome from './pages/colata-home';
import ColataConfigurazione from './pages/colata-configurazione';
import ColataMagazzino from './pages/colata-magazzino';
import ColataInterventi from './pages/colata-interventi';
import ColataStorico from './pages/colata-storico';
import ColataStatistiche from './pages/colata-statistiche';

import InventoryTableView from "pages/home-inventory/components/InventoryTableView";

import LandingAuthentication from './pages/landing-authentication';
import HomeDashboardOwner from './pages/home-dashboard-owner';
import CreaAzienda from "pages/crea-azienda";
import CreaDipendente from "pages/crea-dipendente";
import CreaPartner from "pages/crea-partner";
import HomeDashboardDipendente from "pages/home-dashboard-dipendente";
import ProtectedRoute from "./ProtectedRoute";

import DettagliDipendente from "components/navigation/DettagliDipendente"; 
import ProfiloPage from './pages/mio-profilo';
import MyDocuments from './pages/MyDocuments';
import QrCodeReader from './pages/qr-code-reader'; 
import ResetPasswordPage from './pages/ResetPasswordPage';
import InvitePage from './pages/InvitePage';

import LegalPage from "pages/legal-page";
import OrizonDesk from "pages/orizon-desk";
import ContactPage from "pages/contact";
import TestPage from "pages/test";


import PaymentSuccess from './pages/payment-success';
import RenewalSuccess from './pages/renewal-success';

import GestioneFeriePage from "pages/ferie-admin";

import GodisnjiPage from "pages/moj-godisnji";

import CambiaPassword from './pages/cambia-password';
import SettingPage from "pages/settings";
import DocumentsCompanyPage from "pages/documents-company";
import ListaCompanyPage from "pages/lista-company";
import NotActive from "pages/NotActive"; 

import CompanyNotActive from "pages/CompanyNotActive"; 
import LoginPage from "pages/login-page";
import LoginPWA from "pages/login-pwa";
import BasicPage from "pages/basic-pack";
import BasicPageMonthly from "pages/basic-pack-monthly";
import PremiumPage from "pages/premium-pack";
import PremiumPageMonthly from "pages/premium-pack-monthly";
import EnterprisePage from "pages/enterprise-pack";
import EnterprisePageMonthly from "pages/enterprise-pack-monthly";
import AdminMenuPage from "pages/admin-menu-page";
import ListaPartner from "pages/lista-partner";

import DettagliPartner from "components/navigation/DettagliPartner"; 

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<LandingAuthentication />} />
        <Route path="/landing-authentication" element={<LandingAuthentication />} />

         <Route path="/login" element={<LoginPage />} />
          <Route path="/login-pwa" element={<LoginPWA/>} />

        {/* SuperAdmin / Admin / Owner Dashboard */}
        <Route path="/home-dashboard" element={
          <ProtectedRoute allowedRoles={['superAdmin', 'Admin', 'Owner']}>
            <HomeDashboard />
          </ProtectedRoute>
        } />

  {/* SuperAdmin / Admin / Owner Dashboard */}
        <Route path="/home-mia-azienda" element={
          <ProtectedRoute allowedRoles={['superAdmin', 'Admin', 'Owner']}>
            <HomeMyCompany />
          </ProtectedRoute>
        } />

            {/* SuperAdmin / Admin / Owner Dashboard */}
        <Route path="/stats" element={
          <ProtectedRoute allowedRoles={['superAdmin', 'Admin', 'Owner']}>
            <StatsDashboard />
          </ProtectedRoute>
        } />

                 {/* SuperAdmin / Admin / Owner Dashboard */}
        <Route path="/history_payments" element={
          <ProtectedRoute allowedRoles={['superAdmin', 'Admin', 'Owner']}>
            <HistoryPayments />
          </ProtectedRoute>
        } />

        {/* DODAJ OVU RUTU OVDE: */}
        <Route path="/dipendente/:id" element={
          <ProtectedRoute allowedRoles={['Owner', 'Admin', 'superAdmin']}>
            <DettagliDipendente />
          </ProtectedRoute>
        } />



<Route
  path="/partner/:id"
  element={
    <ProtectedRoute allowedRoles={['Owner', 'Admin', 'superAdmin']}>
      <DettagliPartner />
    </ProtectedRoute>
  }
/>

{/* NOVA RUTA: Dinamički prikaz konkretne tabele */}
<Route path="/dashboard/inventory/table/:tableName" element={
  <ProtectedRoute allowedRoles={['superAdmin', 'Admin', 'Owner']}>
    <InventoryTableView />
  </ProtectedRoute>
} />


<Route path="/payment-success" element={<PaymentSuccess />} />

<Route path="/renewal-success" element={<RenewalSuccess />} />


             {/* SuperAdmin / Admin / Owner Dashboard */}
        <Route path="/home-inventory" element={
          <ProtectedRoute allowedRoles={['superAdmin', 'Admin', 'Owner']}>
            <HomeInventory />
          </ProtectedRoute>
        } />

        {/* SuperAdmin / Admin / Owner Dashboard */}
        <Route path="/acv-home" element={
          <ProtectedRoute allowedRoles={['superAdmin', 'Admin', 'Owner','cco-admin', 'gru-admin', 'cco-utente']}>
            <AcvHome />
          </ProtectedRoute>
        } />


        {/* SuperAdmin / Admin / Owner Dashboard */}
        <Route path="/cco-home" element={
          <ProtectedRoute allowedRoles={['superAdmin', 'Admin', 'Owner', 'cco-utente', 'cco-admin', 'gru-admin']}>
            <CCOHome />
          </ProtectedRoute>
        } />

    {/* SuperAdmin / Admin / Owner Dashboard */}
        <Route path="/ricambi-cco" element={
          <ProtectedRoute allowedRoles={['superAdmin', 'Admin', 'Owner', 'cco-utente', 'cco-admin', 'gru-admin']}>
            <RicambiCCO />
          </ProtectedRoute>
        } />

          {/* SuperAdmin / Admin / Owner Dashboard */}
        <Route path="/storico-cco" element={
          <ProtectedRoute allowedRoles={['superAdmin', 'Admin', 'Owner', 'cco-utente', 'cco-admin', 'gru-admin']}>
            <StoricoCCO />
          </ProtectedRoute>
        } />


      {/* SuperAdmin / Admin / Owner Dashboard */}
        <Route path="/cilindri-paniera" element={
          <ProtectedRoute allowedRoles={['superAdmin', 'Admin', 'Owner', 'cco-utente', 'cco-admin']}>
            <CilindriPaniera />
          </ProtectedRoute>
        } />

 {/* SuperAdmin / Admin / Owner Dashboard */}
        <Route path="/raddrizzatrici" element={
          <ProtectedRoute allowedRoles={['superAdmin', 'Admin', 'Owner', 'cco-utente', 'cco-admin']}>
            <RaddrizzatriciCCO />
          </ProtectedRoute>
        } />

        {/* GRU (carriponti): solo cco-admin, gru-admin e Owner — l'RLS in database impone gli stessi permessi */}
        <Route path="/gru-inventory" element={
          <ProtectedRoute allowedRoles={['cco-admin', 'gru-admin', 'Owner']}>
            <GruHome />
          </ProtectedRoute>
        } />

        <Route path="/gru-magazzino" element={
          <ProtectedRoute allowedRoles={['cco-admin', 'gru-admin', 'Owner']}>
            <GruMagazzino />
          </ProtectedRoute>
        } />

        <Route path="/gru-interventi" element={
          <ProtectedRoute allowedRoles={['cco-admin', 'gru-admin', 'Owner']}>
            <GruInterventi />
          </ProtectedRoute>
        } />

        <Route path="/gru-storico" element={
          <ProtectedRoute allowedRoles={['cco-admin', 'gru-admin', 'Owner']}>
            <GruStorico />
          </ProtectedRoute>
        } />

        <Route path="/gru-statistiche" element={
          <ProtectedRoute allowedRoles={['cco-admin', 'gru-admin', 'Owner']}>
            <GruStatistiche />
          </ProtectedRoute>
        } />

        <Route path="/gru-configurazione" element={
          <ProtectedRoute allowedRoles={['cco-admin', 'gru-admin', 'Owner']}>
            <GruConfigurazione />
          </ProtectedRoute>
        } />

        {/* COLATA (inventario per zone): cco-admin e Owner scrivono, gru-admin sola lettura — l'RLS in database impone gli stessi permessi */}
        <Route path="/colata-inventory" element={
          <ProtectedRoute allowedRoles={['cco-admin', 'gru-admin', 'Owner']}>
            <ColataHome />
          </ProtectedRoute>
        } />

        <Route path="/colata-configurazione" element={
          <ProtectedRoute allowedRoles={['cco-admin', 'gru-admin', 'Owner']}>
            <ColataConfigurazione />
          </ProtectedRoute>
        } />

        <Route path="/colata-magazzino" element={
          <ProtectedRoute allowedRoles={['cco-admin', 'gru-admin', 'Owner']}>
            <ColataMagazzino />
          </ProtectedRoute>
        } />

        <Route path="/colata-interventi" element={
          <ProtectedRoute allowedRoles={['cco-admin', 'gru-admin', 'Owner']}>
            <ColataInterventi />
          </ProtectedRoute>
        } />

        <Route path="/colata-storico" element={
          <ProtectedRoute allowedRoles={['cco-admin', 'gru-admin', 'Owner']}>
            <ColataStorico />
          </ProtectedRoute>
        } />

        <Route path="/colata-statistiche" element={
          <ProtectedRoute allowedRoles={['cco-admin', 'gru-admin', 'Owner']}>
            <ColataStatistiche />
          </ProtectedRoute>
        } />


        <Route path="/crea-azienda" element={
          <ProtectedRoute allowedRoles={['Owner']}>
            <CreaAzienda/>
          </ProtectedRoute>
        } />

        <Route path="/home-dashboard-owner" element={
          <ProtectedRoute allowedRoles={['Owner']}>
            <HomeDashboardOwner />
          </ProtectedRoute>
        } />

        <Route path="/crea-dipendente" element={
          <ProtectedRoute allowedRoles={['Owner', 'Admin', 'superAdmin']}>
            <CreaDipendente/>
          </ProtectedRoute>
        } />

     <Route path="/crea-partner" element={
          <ProtectedRoute allowedRoles={['Owner', 'Admin', 'superAdmin']}>
            <CreaPartner/>
          </ProtectedRoute>
        } />

            <Route path="/lista-partner" element={
          <ProtectedRoute allowedRoles={['Owner', 'Admin', 'superAdmin']}>
            <ListaPartner/>
          </ProtectedRoute>
        } />

        <Route path="/restore-documents" element={
          <ProtectedRoute allowedRoles={['Owner', 'Admin', 'superAdmin']}>
            <CestinoAziendale/>
          </ProtectedRoute>
        } />

        <Route path="/home-dashboard-dipendente" element={
          <ProtectedRoute allowedRoles={['User', 'Admin', 'Owner', 'superAdmin']}>
            <HomeDashboardDipendente />
          </ProtectedRoute>
        } />

           <Route path="/log-audit-user" element={
          <ProtectedRoute allowedRoles={['User', 'Admin', 'Owner', 'superAdmin']}>
            <LogAuditUser />
          </ProtectedRoute>
        } />


<Route path="/change-password" element={<CambiaPassword />} />
       
      
<Route path="/my-documents" element={
  <ProtectedRoute allowedRoles={['User', 'Admin', 'Owner', 'superAdmin']}>
    <MyDocuments />
  </ProtectedRoute>
} />

<Route path="/my-holidays" element={
  <ProtectedRoute allowedRoles={['User', 'Admin', 'Owner', 'superAdmin']}>
    <GodisnjiPage />
  </ProtectedRoute>
} />

<Route path="/admin-holidays" element={
  <ProtectedRoute allowedRoles={['Admin', 'Owner', 'superAdmin']}>
    <GestioneFeriePage />
  </ProtectedRoute>
} />


<Route path="/settings" element={
  <ProtectedRoute allowedRoles={['User', 'Admin', 'Owner', 'superAdmin']}>
    <SettingPage />
  </ProtectedRoute>
} />

<Route path="/documents-company" element={
  <ProtectedRoute allowedRoles={['Admin', 'Owner', 'superAdmin']}>
    <DocumentsCompanyPage />
  </ProtectedRoute>
} />

<Route path="/admin-menu-page" element={
  <ProtectedRoute allowedRoles={['Admin', 'Owner', 'superAdmin']}>
    <AdminMenuPage />
  </ProtectedRoute>
} />

<Route path="/lista-companies" element={
  <ProtectedRoute allowedRoles={['Owner']}>
    <ListaCompanyPage />
  </ProtectedRoute>
} />


<Route path="/qr-code-reader" element={
  <ProtectedRoute allowedRoles={['qrScanner']}>
    <QrCodeReader />
  </ProtectedRoute>
} />


        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />

        <Route path="/mio-profilo" element={<ProfiloPage />} />
<Route path="/legal-page" element={<LegalPage />} />
<Route path="/orizon-desk" element={<OrizonDesk />} />

<Route path="/contact" element={<ContactPage />} />

<Route path="/test" element={<TestPage />} />

<Route path="/premium-pack" element={<PremiumPage />} />
<Route path="/premium-pack-monthly" element={<PremiumPageMonthly />} />

<Route path="/basic-pack" element={<BasicPage />} />
<Route path="/basic-pack-monthly" element={<BasicPageMonthly />} />

<Route path="/enterprise-pack" element={<EnterprisePage />} />
<Route path="/enterprise-pack-monthly" element={<EnterprisePageMonthly />} />



<Route path="/reset-password" element={<ResetPasswordPage />} />

<Route path="/confirm-registration" element={<InvitePage />} />


<Route path="/not-active" element={<NotActive />} />
<Route path="/company-not-active" element={<CompanyNotActive />} />


      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;